<div
  [class.full]="isFull()"
  [class.large]="isLarge()"
  [class.medium]="isMedium()"
  [class.sidebar]="isSidebar()"
  [class.myre-modal]="!isSidebar()"
  [style.width.px]="sidebarWidth()"
  [style.right.%]="isRightSidebar() ? 0 : 'unset'"
  [style.background-color]="modal().backgroundColor"
  [attr.myre-modal-key]="modal().key ?? modal().uid"
>
  <form name="form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    @if (!isSidebar()) {
      <span class="myre-modal-close" (click)="closeModal()">
        <i class="myre-icon-close"></i>
      </span>
    }

    <div class="myre-modal-header" [class.hidden]="!modal().header">
      <var #header></var>
    </div>

    @if (modal().header) {
      <myre-separator [withVerticalSpace]="false" />
    }

    <div
      class="myre-modal-body"
      [class.delete]="isInfo() || isOther() || isWarning()"
    >
      <var #body></var>
    </div>

    @if (modal().footer && !isInfo() && !isWarning() && !isOther()) {
      <myre-separator [withVerticalSpace]="false" />
    }

    <div
      class="myre-modal-footer"
      [class.hidden]="!modal().footer"
      [class.delete]="isInfo() || isOther() || isWarning()"
    >
      <var #footer></var>
    </div>
  </form>
</div>

@if (isSidebar()) {
  <span
    class="myre-modal-close"
    [style.left]="isLeftSidebar() ? closeButtonWidth() + 'px' : 'unset'"
    [style.right]="isRightSidebar() ? closeButtonWidth() + 'px' : 'unset'"
    (click)="closeModal()"
  >
    <i class="myre-icon-close"></i>
  </span>
}
